/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveBankruptcyConsequencesRequest
 */
export interface SaveBankruptcyConsequencesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    hasOwnCheckingAccount?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    isCheckingAccountOverdrawn?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    hasRegisteredMobilePhone?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    isElectricityInOwnName?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    isApartmentDistrictHeated?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    isDistrictHeatingInOwnName?: boolean | null;
}

/**
 * Check if a given object implements the SaveBankruptcyConsequencesRequest interface.
 */
export function instanceOfSaveBankruptcyConsequencesRequest(value: object): value is SaveBankruptcyConsequencesRequest {
    return true;
}

export function SaveBankruptcyConsequencesRequestFromJSON(json: any): SaveBankruptcyConsequencesRequest {
    return SaveBankruptcyConsequencesRequestFromJSONTyped(json, false);
}

export function SaveBankruptcyConsequencesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveBankruptcyConsequencesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hasOwnCheckingAccount': json['hasOwnCheckingAccount'] == null ? undefined : json['hasOwnCheckingAccount'],
        'isCheckingAccountOverdrawn': json['isCheckingAccountOverdrawn'] == null ? undefined : json['isCheckingAccountOverdrawn'],
        'hasRegisteredMobilePhone': json['hasRegisteredMobilePhone'] == null ? undefined : json['hasRegisteredMobilePhone'],
        'isElectricityInOwnName': json['isElectricityInOwnName'] == null ? undefined : json['isElectricityInOwnName'],
        'isApartmentDistrictHeated': json['isApartmentDistrictHeated'] == null ? undefined : json['isApartmentDistrictHeated'],
        'isDistrictHeatingInOwnName': json['isDistrictHeatingInOwnName'] == null ? undefined : json['isDistrictHeatingInOwnName'],
    };
}

export function SaveBankruptcyConsequencesRequestToJSON(json: any): SaveBankruptcyConsequencesRequest {
    return SaveBankruptcyConsequencesRequestToJSONTyped(json, false);
}

export function SaveBankruptcyConsequencesRequestToJSONTyped(value?: SaveBankruptcyConsequencesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasOwnCheckingAccount': value['hasOwnCheckingAccount'],
        'isCheckingAccountOverdrawn': value['isCheckingAccountOverdrawn'],
        'hasRegisteredMobilePhone': value['hasRegisteredMobilePhone'],
        'isElectricityInOwnName': value['isElectricityInOwnName'],
        'isApartmentDistrictHeated': value['isApartmentDistrictHeated'],
        'isDistrictHeatingInOwnName': value['isDistrictHeatingInOwnName'],
    };
}

